import { LanguagesEnum } from '@/api/enums';
import { QuestionType } from '@/client/quizzes';
import { TranslationFunctionType } from '@/common/types';
import { array, number, object, string } from 'yup';

export const surveySchema = (
  t: TranslationFunctionType,
  hasValidOption: boolean,
  selectedTab: LanguagesEnum,
) =>
  object({
    title: string().required(t('error.requiredField')),
    account: string().nullable(),
    type: string().required(),
    questions: array()
      .of(
        object({
          label: string().required(t('error.requiredField')),
          type: string().required(t('error.requiredField')),
          translations: object().shape({
            [selectedTab]: object().shape({
              text: hasValidOption
                ? string()
                : string().required(t('error.requiredField')),
            }),
          }),
          scaleMin: number()
            .typeError(t('error.enterNumber'))
            .when('type', {
              is: (type: string) => type === QuestionType.RATING_SCALE,
              then: (schema) => schema.required(t('error.requiredField')),
              otherwise: (schema) => schema.notRequired(),
            }),
          scaleMax: number()
            .typeError(t('error.enterNumber'))
            .when('type', {
              is: (type: string) => type === QuestionType.RATING_SCALE,
              then: (schema) => schema.required(t('error.requiredField')),
              otherwise: (schema) => schema.notRequired(),
            }),
          scaleMinLabel: string().nullable(),
          scaleMaxLabel: string().nullable(),
        }),
      )
      .min(1, t('error.requiredField')),
  });
